/**
 * CSS
 */
import '../css/dskrpt.scss'

// Core Components
import '../../core/static/js/notification-menu'
import '../../chapter/static/js/dskrpt-footnote'
import '../../usergroups/static/js/add-members'
import '../../script/static/js/unsplash-input'

// Localization
import {configureLocalization} from '@lit/localize';
import {sourceLocale, targetLocales} from './locale/locales';

// HTMX
import 'htmx.org';
import Sortable from "sortablejs";

export const {getLocale, setLocale} = configureLocalization({
    sourceLocale: sourceLocale,
    targetLocales: targetLocales,
    loadLocale: (locale) => import('./locale/de-DE'),
});

// This atrocity is required because Safari <15.0 returns 'de-DE' rather
// than the standard 'de-DE'
try {
    setLocale(
        navigator.language === 'de-de' || navigator.language === 'de'
            ? 'de-DE'
            : navigator.language
    )
} catch {
    setLocale('de-DE')
}
htmx.onLoad(function (content) {
    var sortables = content.querySelectorAll(".sortable");
    for (var i = 0; i < sortables.length; i++) {
        var sortable = sortables[i];
        new Sortable(sortable, {
            animation: 150,
            ghostClass: 'blue-background-class'
        });
    }
})
